import {Component, OnInit} from '@angular/core';
import {DocumentViewerPageComponent} from '../../shared/components/document-viewer-page/document-viewer-page.component';
import {LangService} from '../../core/services/lang.service';
import {LegalDocumentsService} from '../../core/services/legal-documents.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  imports: [DocumentViewerPageComponent]
})
export class TermsAndConditionsComponent implements OnInit{
  url: string = '';

  constructor(private langService: LangService, private legalDocumentsService: LegalDocumentsService) {
  }

  ngOnInit(): void {
    this.legalDocumentsService.getTermsAndConditions(this.langService.currentLang()).subscribe(url => {
      this.url = url;
    });
  }
}
